import { createFileRoute } from '@tanstack/react-router';
import { RouteTab } from '@/features/shipment-detail/route/route-tab';

// S04 · Route (07 §3).
export const Route = createFileRoute('/_app/shipments/$id/route')({
  component: RouteTab,
});
